import React from 'react'
import { getStyles } from '../../utils/utils/commonUtils'
import carouselStyles from './style/carouselStyle'

const SlideImage = ({ imageSrc, zoom, active, coords, i, styles = {} }) => {
  const classes = getStyles(carouselStyles)

  const scaleValue = zoom === 2 ? 'scale(5)' : 'scale(2.5)'

  return (
    <img
      id={`slide-image-${i}`}
      style={{
        ...classes.slideImage,
        transform: zoom && active ? scaleValue : '',
        transformOrigin: `${coords.x}% ${coords.y}%`,
        ...styles,
      }}
      src={imageSrc}
      alt={'slide'}
    />
  )
}

export default SlideImage
